<template>
  <b-card no-body class="card-default mt-3 vh-85">
    <div slot="header">
      <strong>Guías Educativas</strong>
    </div>
    <b-card-text>
      <b-col>
        <b-row>
          <b-col cols="12">
            <b-row class="text-center" style="margin-top: 40px;">
              <slot v-if="cursos.length">
                <template v-for="(c,i) in cursos">
                  <b-col
                    :key="i"
                    lg="2"
                    md="3"
                    sm="6"
                    class="box-element item-list-view animated fadeIn"
                    @dblclick="openDir(c)"
                  >
                    <b-dropdown
                      size="sm"
                      dropleft
                      variant="light"
                      class="m-0 icon-options-item"
                      no-caret
                      v-if="showButtons"
                    >
                      <template slot="button-content">
                        <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
                      </template>
                      <div>
                        <b-dropdown-item @click="openDir(c)">Mostrar Guías</b-dropdown-item>
                      </div>
                    </b-dropdown>
                    <font-awesome-icon
                      icon="folder"
                      class="icon-dir"
                      v-b-popover.hover.bottom="c.name"
                    />
                    <span class="d-block text-center" variant="primary">{{c.name}}</span>
                  </b-col>
                </template>
              </slot>
              <slot v-else>
                <b-col class="empty-folder animated fadeIn">
                  <font-awesome-icon icon="folder" class="icon-dir" />
                  <p>La Carpeta Está Vacía</p>
                </b-col>
              </slot>
            </b-row>
          </b-col>          
        </b-row>
      </b-col>
      <!--<b-tabs pills card vertical nav-wrapper-class="w-auto" style="height: 80vh">
        <b-tab v-for="c in cursos" :key="c._id" :title="c.name" :title-link-class="linkClass()">
          <b-card-text>
            <b-col cols="12">
              <b-row class="text-center">
                <slot v-if="c.guiasEducativas.length">
                  <template v-for="(g,i) in c.guiasEducativas">
                    <b-col
                      :key="i"
                      lg="2"
                      md="3"
                      sm="6"
                      class="box-element item-list-view animated fadeIn"
                      @dblclick="mostrarGuia(g)"
                    >
                      <b-dropdown
                        size="sm"
                        dropleft
                        variant="light"
                        class="m-0 icon-options-item"
                        no-caret
                        v-if="showButtons"
                      >
                        <template slot="button-content">
                          <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
                        </template>
                        <b-dropdown-item @click="mostrarGuia(g)">Mostrar</b-dropdown-item>
                      </b-dropdown>
                      <font-awesome-icon
                        v-b-popover.hover.bottom="g.tag"
                        v-if="g.type == 'image'"
                        icon="file-image"
                        class="icon-dir"
                      />
                      <font-awesome-icon
                        v-b-popover.hover.bottom="g.tag"
                        v-if="g.type == 'video'"
                        icon="file-video"
                        class="icon-dir"
                      />
                      <font-awesome-icon
                        v-b-popover.hover.bottom="g.tag"
                        v-if="g.type == 'application'"
                        icon="file-pdf"
                        class="icon-dir"
                      />
                      <span class="d-block text-center" variant="primary">{{g.tag}}</span>
                    </b-col>
                  </template>
                </slot>
                <slot v-else>
                  <b-col class="empty-folder animated fadeIn">
                    <font-awesome-icon icon="folder" class="icon-dir" />
                    <p>La Carpeta Esta Vacía</p>
                  </b-col>
                </slot>
              </b-row>
            </b-col>
          </b-card-text>
        </b-tab>
      </b-tabs>-->
    </b-card-text>

    <!-- Modal recursos -->
    <ModalVisualizarGuia :showModal="showModal" v-on:closeModal="showModal = $event" :guia="guia"></ModalVisualizarGuia>
  </b-card>
</template>
<style lang="scss" scoped>
.card-header {
  font-weight: normal !important;
}
.title-header-collapse {
  cursor: pointer;
}
.item-list-view {
  border-radius: 10px;
  padding: 5px;
  margin: 5px;
  cursor: pointer;
  &:hover {
    background-color: rgba(218, 235, 241, 0.5);

    .icon-options-item {
      visibility: initial;
    }
  }
  svg,
  span {
    text-align: center;
    //margin-right: 20px;
  }
}
.icon-options-item {
  visibility: hidden;
  position: absolute;
  right: 5px;
}

.icon-dir {
  display: block;
  margin: auto;
  font-size: 4rem;
  color: #30a8d8;
}

.empty-folder {
  margin-top: 6rem;

  svg,
  p {
    text-align: center;
    color: #c8ced2;
  }

  p {
    font-size: 1.2rem;
    font-weight: bold;
  }
}
.d-block {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 10px;
}
</style>
<script>
import {
  sidebarCssClasses,
  asideMenuCssClasses,
  validBreakpoints,
  checkBreakpoint
} from "@coreui/vue/src/shared/classes";

import ModalVisualizarGuia from "@/components/ModalVisualizarGuia";

export default {
  name: "Guias",
  props: {
    showButtons: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showModal: false,
      guia: null
    };
  },
  components: {
    ModalVisualizarGuia
  },
  methods: {
    linkClass() {
      return ["bg-default", "text-light"];
    },
    mostrarGuia(g) {
      this.guia = g;
      this.showModal = true;
      //console.log(g);
    },
    openDir(curso) {
      this.$router.push({ name: "GuiasList", params: { id: curso._id } });
      console.log(curso);
    },    
  },
  computed: {
    cursos: function() {
      return this.$store.getters["directorio/getListCursos"];
    }
  }
};
</script>